module.exports = __webpack_public_path__ + "static/media/ai-ad-elsayedthumbnailMOBILE.50807559.png";